import React from 'react';
import { DotLoader } from 'react-spinners';

import { styled } from '../theme';

type Props = {
    backdrop?: boolean;
    centered?: boolean;
    size?: 'small' | 'default';
    color?: string;
};

const Container = styled('div')<Props>(({ theme, backdrop, centered, size, color }) => ({
    display: 'flex',
    justifyContent: 'center',
    ['& > span']: {
        width: size === 'default' ? 60 : 40,
        height: size === 'default' ? 60 : 40,
    },
    ['& > span > span']: {
        backgroundColor: color || theme.color.surface,
        width: size === 'default' ? 30 : 20,
        height: size === 'default' ? 30 : 20,
    },

    ...(backdrop && {
        backgroundColor: theme.color.backdropBackground,
    }),

    ...(centered
        ? {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              alignItems: 'center',
          }
        : {
              marginTop: 45,
              paddingRight: 30,
          }),
}));

const Loading = ({ backdrop = false, centered, size = 'default', color, ...props }: Props) => {
    return (
        <Container
            backdrop={backdrop}
            centered={centered != null ? centered : backdrop}
            size={size}
            color={color}
            {...props}
        >
            <DotLoader backdrop={backdrop} />
        </Container>
    );
};

export default Loading;
